import { z } from "zod";

/** News und Ankündigungen von Logiful an die Kunden (Kachel auf der Übersicht) */
export const announcementAudienceSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("all") }),
  /** Kunden, die eines dieser Lager nutzen (FFN warehouseId) */
  z.object({ type: z.literal("warehouses"), ids: z.array(z.string().min(1)).min(1, "Mindestens ein Lager wählen") }),
  z.object({ type: z.literal("tenants"), ids: z.array(z.string().uuid()).min(1, "Mindestens einen Kunden wählen") }),
]);
export type AnnouncementAudience = z.infer<typeof announcementAudienceSchema>;

export const announcementInputSchema = z.object({
  title: z.string().trim().min(3, "Titel fehlt").max(140),
  body: z.string().trim().max(4000).default(""),
  level: z.enum(["info", "important"]).default("info"),
  pinned: z.boolean().default(false),
  audience: announcementAudienceSchema.default({ type: "all" }),
  /** ab wann sichtbar (Standard: sofort) */
  publishAt: z.coerce.date().nullable().default(null),
  /** bis wann sichtbar (leer = unbegrenzt) */
  visibleUntil: z.coerce.date().nullable().default(null),
}).refine((a) => !a.publishAt || !a.visibleUntil || a.visibleUntil > a.publishAt, { message: "„Sichtbar bis“ muss nach dem Start liegen", path: ["visibleUntil"] });
export type AnnouncementInput = z.infer<typeof announcementInputSchema>;

/** Sieht dieser Kunde die Ankündigung? */
export function announcementVisibleFor(a: { audience: AnnouncementAudience }, tenant: { id: string; warehouseIds: string[] }): boolean {
  if (a.audience.type === "all") return true;
  if (a.audience.type === "tenants") return a.audience.ids.includes(tenant.id);
  return a.audience.ids.some((w) => tenant.warehouseIds.includes(w));
}

/** Fester Anliefertermin eines Wareneingangs (z. B. Container) – Uhrzeit in deutscher Zeit */
export const inboundAppointmentSchema = z.object({
  /** YYYY-MM-DD */
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Datum fehlt"),
  /** HH:MM */
  from: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Uhrzeit von fehlt"),
  to: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).nullable().default(null),
  note: z.string().trim().max(300).nullable().default(null),
}).refine((a) => !a.to || a.to > a.from, { message: "„bis“ muss nach „von“ liegen", path: ["to"] });
export type InboundAppointment = z.infer<typeof inboundAppointmentSchema>;
